import { get } from 'styled-system';
import curry from 'lodash/curry';

// Utility to remove extra white space from top and bottom of text
export const basekick = curry((fontSize, lineHeight, { theme, fontFamily }) => {
  const themeKey = fontFamily || 'standard';
  const config = get(theme, `fontMeta.${themeKey}`, get(theme, 'fontMeta.standard'));
  if (!config) {
    return {};
  }
  const lineHeightScale = lineHeight / fontSize;
  const typeOffset = (lineHeightScale - 1) / 2 + config.descenderHeightScale;
  const typeCorrection = lineHeightScale - 1 + (1 - config.capHeightScale);

  return {
    paddingTop: '0.1px',
    transform: `translateY(${typeOffset}em)`,

    '&::before': {
      content: '""',
      display: 'block',
      height: 0,
      marginTop: `${-1 * typeCorrection}em`,
    },
  };
});

export const basekickLineheightScale = curry((lineHeightScale, props) => {
  return basekick(1, lineHeightScale, props);
});

const focusVisibleNative = '&focus-visible';
const focusVisiblePolyfill = '&[data-focus-visible-added]:focus';

export function focusVisible(styles) {
  return {
    [`${focusVisibleNative},${focusVisiblePolyfill}`]: styles,
  };
}

export function focusRing(theme, radius) {
  const defaultKey = 'focus';
  const defaultShadow = theme.shadows[defaultKey];
  radius = typeof radius === 'string' ? theme.radii[radius] ?? radius : radius;
  return {
    boxShadow: `var(--focus-shadow, ${defaultShadow})`,
    borderRadius: radius,
  };
}

export function focusVisibleRing(radius) {
  return ({ theme }) => focusVisible(focusRing(theme, radius));
}

function isObject(value) {
  return value != null && !Array.isArray(value) && typeof value === 'object';
}

export function mapResponsive(prop, mapper) {
  if (Array.isArray(prop)) {
    return prop.map((item) => {
      if (item === null) {
        return null;
      }
      return mapper(item);
    });
  }

  if (isObject(prop)) {
    return Object.keys(prop).reduce((result, key) => {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }

  if (prop != null) {
    return mapper(prop);
  }

  return null;
}
